<template>
    <div class="imgcard">
        <el-row :gutter="20">
            <el-col :span="8" v-for="(item,index) in list" :key="index">
                <div class="imgcard-container">
                    <img src="item.photo1" alt="">
                </div>
            </el-col>
            <!-- <el-col :span="8">
                <div class="grid-content bg-purple"></div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple"></div>
            </el-col> -->
        </el-row>
    </div>
</template>
<script>
export default {
    data(){
        return{}
    },
    props:['list']
}
</script>




// WEBPACK FOOTER //
// src/components/imgCard.vue